import { Block } from "framework7-react";

import { formatShortDateTime } from "@/config/date-fns";
import { EntryFragment, FeelingEnum } from "@/generated/graphql/graphql";
import feelingBad from "@/images/feeling-bad.png";
import feelingGood from "@/images/feeling-good.png";
import feelingUnset from "@/images/feeling-unset.png";

import { CategoryChip } from "./CategoryChip";

type EntrySummaryProps = { entry: EntryFragment | null | undefined };

export function EntrySummary({ entry }: EntrySummaryProps) {
  const feelingImage = (() => {
    switch (entry?.feelingKey) {
      case FeelingEnum.Good:
        return feelingGood;
      case FeelingEnum.Bad:
        return feelingBad;
      default:
        return feelingUnset;
    }
  })();

  const timeRange = (() => {
    if (!entry) return "";
    const start = formatShortDateTime(entry.startAt);
    const end = entry.endAt ? formatShortDateTime(entry.endAt) : "";
    return `${start} ~ ${end}`;
  })();

  if (entry) {
    return (
      <Block
        strong
        className="no-margin"
      >
        <div style={{ alignItems: "center", display: "flex", gap: "12px" }}>
          <img
            alt={entry.feelingKey}
            src={feelingImage}
            style={{ height: 56, width: 56 }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600 }}>{entry.activityName}</div>
            <div style={{ color: "var(--f7-text-color)", fontSize: 12, marginTop: 2 }}>{timeRange}</div>
            {entry.categoryKey && (
              <div style={{ marginTop: 6 }}>
                <CategoryChip categoryKey={entry.categoryKey} />
              </div>
            )}
          </div>
        </div>
      </Block>
    );
  }

  return null;
}
